module.exports = __webpack_public_path__ + "media/thankyou_message_5.20cc1b64.mp3";